import { Constants } from '@pwc/pwc-deals-web-common';
import _get from 'lodash/get';
import _flatMap from 'lodash/fp/flatMap';
import _filter from 'lodash/fp/filter';
import _pipe from 'lodash/fp/pipe';
import _values from 'lodash/values';
import { createSelector } from 'reselect';
import { ADJUSTMENT_TOGGLES_BY_DOCUMENT_KEY } from '../utilities/constants';

export const getAdjustmentTogglesByDocument = (state) =>
  _get(state, ADJUSTMENT_TOGGLES_BY_DOCUMENT_KEY, {});

export const createSelectorGetAdjustmentTogglesForDocumentCode = (
  documentCode
) =>
  createSelector(
    getAdjustmentTogglesByDocument,
    (adjustmentTogglesByDocument) =>
      _get(adjustmentTogglesByDocument, documentCode, {})
  );

export const getAdjustmentTogglesForQofE =
  createSelectorGetAdjustmentTogglesForDocumentCode(
    Constants.QUALITY_OF_EARNINGS
  );

export const getAdjustmentTogglesForNwc =
  createSelectorGetAdjustmentTogglesForDocumentCode(
    Constants.NET_WORKING_CAPITAL
  );

export const getAdjustmentTogglesForDdl =
  createSelectorGetAdjustmentTogglesForDocumentCode(
    Constants.DEBT_AND_DEBT_LIKE
  );

export const getAreAdjustmentsToggledFromDefault = createSelector(
  getAdjustmentTogglesByDocument,
  (adjustmentsByDocument) => {
    const inActiveAdjustments = _pipe(
      _values,
      _flatMap(_values),
      _flatMap(_values),
      _filter((x) => x.active === false)
    )(adjustmentsByDocument);
    return inActiveAdjustments.length > 0;
  }
);
